import * as React from 'react';

export const SignIn: React.VoidFunctionComponent<React.SVGProps<SVGSVGElement>> = props => {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
			<path
				d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			></path>
			<polyline
				points="10 17 15 12 10 7"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			></polyline>
			<line
				x1="15"
				x2="3"
				y1="12"
				y2="12"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			></line>
		</svg>
	);
};
